import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import Reveal from "./Reveal";
import { BRAND } from "@/branding.config";

const ROWS = [
  { name: BRAND.company_name, ms: 0.42, brand: true },
  { name: "Provider A",   ms: 3.1 },
  { name: "Provider B",   ms: 5.4 },
  { name: "Provider C",   ms: 9.8 },
  { name: "Retail cloud", ms: 22.6 },
];

export default function LatencyComparison() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const max = Math.max(...ROWS.map((r) => r.ms));

  return (
    <section ref={ref} className="mx-auto max-w-6xl px-6 py-24">
      <Reveal>
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">Latency, measured</div>
        <h2 className="mt-3 text-4xl md:text-5xl font-black tracking-tight">Round-trip to LD4 broker fabric</h2>
        <p className="mt-3 max-w-xl text-muted-foreground">
          10-second average, 1-hour window. Same MT5 hello-world payload from each provider. {BRAND.short_name} runs in the same rack.
        </p>
      </Reveal>

      <div className="mt-10 space-y-3">
        {ROWS.map((r, i) => {
          const width = inView ? `${(r.ms / max) * 100}%` : "0%";
          return (
            <div key={r.name} className="grid grid-cols-[160px_1fr_80px] items-center gap-4">
              <div className={`text-sm ${r.brand ? "font-bold text-foreground" : "text-muted-foreground"}`}>{r.name}</div>
              <div className="h-3 rounded-full bg-white/[0.04] overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width }}
                  transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.1 + i * 0.08 }}
                  className={`h-full ${r.brand
                    ? "bg-gradient-to-r from-violet via-purple to-pink"
                    : "bg-white/10"}`}
                />
              </div>
              <div className={`text-right font-mono text-sm ${r.brand ? "text-primary font-bold" : "text-muted-foreground"}`}>{r.ms.toFixed(2)} ms</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
